(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xx-reference-catalog"] && !Shopify.designMode) return;
  try {
    
function setupXXCatalog(root = document) {
  root.querySelectorAll('[data-xx-sort]').forEach(select => {
    if (select.dataset.xxReady) return;
    select.dataset.xxReady = 'true';
    select.addEventListener('change', () => select.form.requestSubmit());
  });
}
setupXXCatalog();
document.addEventListener('shopify:section:load', event => setupXXCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xx-reference-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',event=>{const node=event.target;if(!node.matches?.('.xx-nav-category')||!node.open)return;node.closest('nav').querySelectorAll('.xx-nav-category').forEach(d=>{if(d!==node)d.open=false})},true);
document.addEventListener('click',event=>{document.querySelectorAll('.xx-nav-category[open]').forEach(d=>{if(!d.contains(event.target))d.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.xx-nav-category[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();
})();
